import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Classificator from '../Classificator';
import ComponentWrapper from './ComponentWrapper';
import mapError from './mapError';

const identity = (p) => p;

export default class ClassificatorField extends Component {
  static types = Classificator.types;

  static propTypes = {
    input: PropTypes.shape({
      value: PropTypes.any,
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      onFocus: PropTypes.func,
    }),
    meta: PropTypes.object,
    classificatorType: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
  };

  render() {
    const {
      input,
      meta,
      classificatorType: classificatorTypeProp, // renamed prop; keep a fallback from legacy `type`
      type: legacyType, // fallback if someone still passes `type`
      value: valueProp,
      onChange: onChangeProp,
      onBlur: onBlurProp,
      onFocus: onFocusProp,
    } = this.props;

    const classificatorType = classificatorTypeProp ?? legacyType;

    const value = input?.value ?? valueProp ?? '';
    const onChange =
      input?.onChange && onChangeProp
        ? (val) => {
            input.onChange(val);
            onChangeProp(val);
          }
        : (input?.onChange ?? onChangeProp);
    const onBlur = input ? () => input.onBlur(value) : onBlurProp;
    const onFocus = input?.onFocus ?? onFocusProp;

    // mapError likely expects redux-form meta; skip it in standalone mode.
    const mapper = input ? mapError : identity;

    return (
      <ComponentWrapper
        {...this.props}
        input={input}
        meta={meta}
        mapProps={mapper}
        render={(props) => (
          <Classificator
            {...props}
            type={classificatorType}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
          />
        )}
      />
    );
  }
}
